import React from 'react';
import Messages from 'services/i18n/Messages';
import { OpenFoodReference } from 'types/types';

type Props = {
  food: OpenFoodReference,
};

export default function EcoProduct({ food }: Props) {
  return (
    <div>
      {
        food['carbon-footprint100g'] && (
          <div>{Messages.t('product.eco.carbonFootprint', { carbonFootprint: food['carbon-footprint100g'] * 10 })}</div>
        )
      }
    </div>
  );
}
